import { render } from "./copy-text.vue?vue&type=template&id=7cddea83"
import script from "./copy-text.vue?vue&type=script&lang=js"
export * from "./copy-text.vue?vue&type=script&lang=js"

import "./copy-text.vue?vue&type=style&index=0&id=7cddea83&lang=less"

import exportComponent from "/home/runner/work/suplasercut-admin/suplasercut-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__